import { TomSelect } from '@vendor/libs/tom-select/tom-select';
import { i18n } from '@vendor/libs/lang/lang';
const _RichSelectHandler = (function () {
    let tomSelectInstances = {};
    return {
        // Public functions
        /**
         * Handles a rich select element.
         *
         * @param {string} id - The ID of the select element.
         * @param {TomSettings} options - The options object for the TomSelect constructor.
         */
        handleRichSelect: function (id, options = {}) {
            let plugins = [];
            if (options.maxItems === null ||
                (typeof options.maxItems == 'number' && options.maxItems > 1)) {
                plugins = [...plugins, 'clear_button', 'remove_button'];
            }
            tomSelectInstances[id] = new TomSelect(id, {
                ...options,
                plugins,
                hideSelected: false,
                highlight: false,
                render: {
                    option_create: function (data, escape) {
                        return ('<div class="create">' +
                            i18n.trans('common.forms.select.add') +
                            ' <strong>' +
                            escape(data.input) +
                            '</strong>&hellip;</div>');
                    },
                    no_results: function (data, escape) {
                        return ('<div class="no-results">' +
                            i18n.trans('common.forms.select.empty') +
                            ' "' +
                            escape(data.input) +
                            '"</div>');
                    },
                    // optgroup: function (data: any) {
                    //   let optgroup = document.createElement('div');
                    //   optgroup.className = 'optgroup';
                    //   optgroup.appendChild(data.options);
                    //   return optgroup;
                    // },
                    // optgroup_header: function (
                    //   data: any,
                    //   escape: (text: string) => string
                    // ) {
                    //   return (
                    //     '<div class="optgroup-header">' + escape(data.label) + '</div>'
                    //   );
                    // },
                },
            });
        },
        //Providing the implementation for clear method
        clear: function (id) {
            let tomSelect = tomSelectInstances[id];
            if (tomSelect) {
                tomSelect.clear();
            }
            else {
                console.error('No TomSelect instance found for id: ' + id);
            }
        },
    };
})();
window.RichSelectHandler = _RichSelectHandler;
